import React from 'react';

function Clock(props) {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M4.92893 4.92893C6.8043 3.05357 9.34783 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34783 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34783 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34783 3.05357 6.8043 4.92893 4.92893ZM12 3.25C9.67935 3.25 7.45376 4.17187 5.81282 5.81282C4.17187 7.45376 3.25 9.67935 3.25 12C3.25 14.3206 4.17187 16.5462 5.81282 18.1872C7.45376 19.8281 9.67935 20.75 12 20.75C14.3206 20.75 16.5462 19.8281 18.1872 18.1872C19.8281 16.5462 20.75 14.3206 20.75 12C20.75 9.67935 19.8281 7.45376 18.1872 5.81282C16.5462 4.17187 14.3206 3.25 12 3.25ZM12 5.9751C12.3452 5.9751 12.625 6.25492 12.625 6.6001V11.375H17.4C17.7452 11.375 18.025 11.6548 18.025 12C18.025 12.3452 17.7452 12.625 17.4 12.625H12.0106C12.0071 12.6251 12.0035 12.6251 12 12.6251C11.6548 12.6251 11.375 12.3453 11.375 12.0001V12V6.6001C11.375 6.25492 11.6548 5.9751 12 5.9751Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Clock;
